"use client";

import { Box, Heading, Link, Text } from "@chakra-ui/react";
import RouterLink from "next/link";
import { useRouter } from "next/navigation";
import { ReactNode } from "react";
import { ContentfulImage } from "../../components/ContentfulImage";
import { formatDate } from "../../utils/formatDate";

import type { ContentEvent } from "../content";

type Props = {
  events: ContentEvent[];
};

export function PageComponent(props: Props): ReactNode {
  const router = useRouter();
  return (
    <>
      <Heading>Termine</Heading>
      {props.events.length === 0 ? (
        <Text mt={4}>Aktuell sind keine Veranstaltungen geplant.</Text>
      ) : null}
      {props.events.map((event) => (
        <Box
          key={event.id}
          borderWidth="1px"
          rounded="lg"
          boxShadow="md"
          overflow="hidden"
          display="flex"
          flexDirection={["column", "column", "column", "row"]}
          mt={4}
          transition="box-shadow 0.1s ease"
          _hover={{ boxShadow: "lg" }}
        >
          {event.imageUrl ? (
            <>
              <Box
                cursor="pointer"
                display={["initial", "initial", "initial", "none"]}
              >
                <ContentfulImage
                  src={event.imageUrl}
                  alt="Titelbild"
                  height={500}
                  width={750}
                  style={{ width: "100%" }}
                  onClick={() => {
                    router.push(`/termine/${event.id}`);
                  }}
                />
              </Box>
              <Box
                cursor="pointer"
                display={["none", "none", "none", "initial"]}
                position="relative"
                flex={1}
              >
                <ContentfulImage
                  src={event.imageUrl}
                  alt="Titelbild"
                  height={500}
                  width={750}
                  style={{ height: "100%", objectFit: "cover" }}
                  onClick={() => {
                    router.push(`/termine/${event.id}`);
                  }}
                />
              </Box>
            </>
          ) : null}
          <Box p={4} flex={2}>
            <Heading as="h3" fontSize="lg">
              {event.title}
            </Heading>
            <Text color="gray.600" mt={1} mb={2}>
              {formatDate(event.date)}
            </Text>
            <Text mb={2}>{event.preview}</Text>
            <Link
              as={RouterLink}
              href={`/termine/${event.id}`}
              color="blue.500"
            >
              Details zum Termin
            </Link>
          </Box>
        </Box>
      ))}
    </>
  );
}
